import styled from "styled-components";
import CardTecnologiaOferecida from "../CardTecnologiaOferecida";

// Imagens tecnologias
import Cardapio from "../../assets/imagens/imagensTecnologias/Cardapio.webp";
import ERPmobile from "../../assets/imagens/imagensTecnologias/ERPmobile.webp";
import EntradaSaida from "../../assets/imagens/imagensTecnologias/EntradaSaida.webp";
import Lumien from "../../assets/imagens/imagensTecnologias/Lumien.webp";
import SmartPOS from "../../assets/imagens/imagensTecnologias/SmartPOS.webp";
import Wayservice from "../../assets/imagens/imagensTecnologias/Wayservice.webp";

const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1em;
`;

const TextoContainer = styled.div``;

const Titulo = styled.h1`
	text-align: left;
	font-weight: var(--strong-weight);
	font-size: var(--bigger-font);
`;

const Subtitulo = styled.h2`
	text-align: left;
	font-weight: var(--weak-weight);
	font-size: var(--small-font);
`;

const CardsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.5em;

	@media screen and (min-width: 650px) {
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: space-around;
	}
`;

export default function TecnologiasOferecidas() {
	return (
		<Container>
			<TextoContainer>
				<Titulo>
					Oferecemos todas as{" "}
					<span style={{ color: "#1B5EA4" }}>tecnologias de gestão</span> que
					você está buscando.
				</Titulo>
				<Subtitulo>
					Transforme os problemas do seu negócio em oportunidades de crescimento
					com as nossas soluções de tecnologia. Tudo centralizado em uma única
					empresa para facilitar para você!
				</Subtitulo>
			</TextoContainer>

			<CardsContainer>
				<CardTecnologiaOferecida
					titulo={
						"Cardápio digital que funciona com delivery e QR code na mesa"
					}
					subtitulo={
						"Crie um cardápio exclusivo para o seu restaurante e destaque sua marca. Automatize o atendimento pelo WhatsApp, organize suas comandas e conquiste a fidelidade dos seus clientes."
					}
					imagem={Cardapio}
					url={`/waymenu`}
				/>

				<CardTecnologiaOferecida
					titulo={
						"Diminua filas e aumente o ticket médio. Conheça o Wayservice"
					}
					subtitulo={
						"O Wayservice traz autonomia para o seu cliente e agilidade para sua cozinha. Reduza filas e aumente o ticket médio com uma experiência de atendimento única e confortável."
					}
					imagem={Wayservice}
					url={`/wayservice`}
				/>

				<CardTecnologiaOferecida
					titulo={"Agilize seus pedidos com o PDV nas maquininhas SmartPOS"}
					subtitulo={
						"Com o PDV na maquininha, você vende, recebe e controla tudo em um só lugar. Sem complicação, sem perder tempo e com muito mais organização para o seu negócio."
					}
					imagem={SmartPOS}
					url={`/waychef`}
				/>

				<CardTecnologiaOferecida
					titulo={
						"Você pode controlar o seu estoque em tempo real com o ERP mobile"
					}
					subtitulo={
						"Integre o Flutt PDV ao Sifat ERP e tenha controle total do seu negócio. Gerencie estoque, curva ABC e mix de produtos em uma interface intuitiva, garantindo adaptação rápida e usabilidade máxima para sua equipe."
					}
					imagem={ERPmobile}
					url={`/sifat-flutt`}
				/>

				<CardTecnologiaOferecida
					titulo={"Automação de bombas e gestão por turnos com o Lumien PDV"}
					subtitulo={
						"Lumien é o PDV integrado para postos de combustíveis que automatiza sua gestão. Com controle de frentistas, fechamento por turno e operação offline, você garante eficiência operacional e um atendimento rápido mesmo offline."
					}
					imagem={Lumien}
					url={`/sifat-lumien`}
				/>

				<CardTecnologiaOferecida
					titulo={"Economize com mão de obra e agilize as filas do seu mercado"}
					subtitulo={
						"Economize com mão de obra e agilize as filas do seu mercado. Conecte o Efex PDV ao Sifat ERP para gerenciar estoque, produtos e clientes com facilidade. Simplifique seu financeiro com acesso a dados essenciais e relatórios que garantem total controle sobre o seu negócio."
					}
					imagem={EntradaSaida}
					url={`/efex-pdv`}
				/>
			</CardsContainer>
		</Container>
	);
}
